import { useEffect,  useState } from 'react';
import Loader from '../Common/Loader';
import SearchApi from '../../Api/SearchApi';
import { useAppSelector } from '../../Reducers/store';
import { SearchRequest } from '../../Models/SearchRequest';
import { SearchResult } from '../../Models/SearchResult';
import { SelectOption } from '../../Models/SelectOption';
import EmailModal from '../Forms/WarehouseAvailability';
import { Equipment } from '../../Models/Equipment';
import SearchListTable from './SearchListTable';

export default function SearchPage() {
  const { equipmentSearchData } = useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<SearchResult[]>([]);
  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem('searchTextState') ?? '',
    searchPartsText: localStorage.getItem('searchPartsTextState') ?? '',
    manufacturers: localStorage.getItem('manufacturersState')
      ? (
          JSON.parse(
            localStorage.getItem('manufacturersState')!
          ) as SelectOption[]
        ).map((a) => a.label!)
      : null,
    categories: localStorage.getItem('categoriesState')
      ? (
          JSON.parse(localStorage.getItem('categoriesState')!) as SelectOption[]
        ).map((a) => a.label!)
      : null,
    subCategories: localStorage.getItem('subCategoriesState')
      ? (
          JSON.parse(
            localStorage.getItem('subCategoriesState')!
          ) as SelectOption[]
        ).map((a) => a.label!)
      : null,
    minPrice: localStorage.getItem('minPriceState')
      ? Math.ceil(Number(localStorage.getItem('minPriceState')))
      : equipmentSearchData?.minPrice
      ? Math.ceil(equipmentSearchData?.minPrice)
      : 0,
    maxPrice: localStorage.getItem('maxPriceState')
      ? Math.ceil(Number(localStorage.getItem('maxPriceState')))
      : equipmentSearchData?.maxPrice
      ? Math.ceil(equipmentSearchData?.maxPrice)
      : 1000,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 1,
  });
  const [showEmailModal, setShowEmailModal] = useState(false);

  const [selectedEquipment, setSelectedEquipment] = useState<Equipment>();
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      searchPartsText: localStorage.getItem('searchPartsTextState') ?? '',
      skip: 0,
      reset: true,
    }));
    getSearchResults();
  }, []);

  const [selectedManufacturerOptions, setSelectedManufacturerOptions] =
    useState<SelectOption[] | null>(
      localStorage.getItem('manufacturersState')
        ? (JSON.parse(
            localStorage.getItem('manufacturersState')!
          ) as SelectOption[])
        : null
    );

  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState<
    SelectOption[] | null
  >(
    localStorage.getItem('categoriesState')
      ? (JSON.parse(localStorage.getItem('categoriesState')!) as SelectOption[])
      : null
  );

  const [selectedSubCategoryOptions, setSelectedSubCategoryOptions] = useState<
    SelectOption[] | null
  >(
    localStorage.getItem('subCategoriesState')
      ? (JSON.parse(
          localStorage.getItem('subCategoriesState')!
        ) as SelectOption[])
      : null
  );

  const getSearchResults = async () => {
    setIsLoading(true);
    if (selectedManufacturerOptions) {
      formData.manufacturers = selectedManufacturerOptions.map(function (item) {
        return item.label!;
      });
      localStorage.setItem(
        'manufacturersState',
        JSON.stringify(selectedManufacturerOptions)
      );
    } else {
      formData.manufacturers = null;
    }
    if (selectedCategoryOptions) {
      formData.categories = selectedCategoryOptions.map(function (item) {
        return item.label!;
      });
      localStorage.setItem(
        'categoriesState',
        JSON.stringify(selectedCategoryOptions)
      );
    } else {
      formData.categories = null;
    }
    if (selectedSubCategoryOptions) {
      formData.subCategories = selectedSubCategoryOptions.map(function (item) {
        return item.label!;
      });
      localStorage.setItem(
        'subCategoriesState',
        JSON.stringify(selectedSubCategoryOptions)
      );
    } else {
      formData.subCategories = null;
    }
    localStorage.setItem('searchTextState', formData.searchText!);
    SearchApi.search(formData)
      .then((res) => {
        if (res.data.length > 0 || formData.reset) {
          if (formData.reset) {
            setSearchData(res.data);
          } else {
            setSearchData(searchData.concat(res.data));
          }
          setFormData((prevData) => ({
            ...prevData,
            reset: false,
          }));
        }
        // setSearchData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   if (searchData.length === 0) {
  //     getSearchResults();
  //   }
  // }, [searchData]);

  useEffect(() => {
    formData.searchText = localStorage.getItem('searchTextState');
    formData.skip = 0;
    formData.reset = true;
    if ((formData.searchText ?? '').length > 0) getSearchResults();
  }, [localStorage.getItem('searchTextState')]);

  return (
    <>
      <div className='w-full pt-4'>
        <div className='mx-auto p-2'>
          <div className='flex mb-2 border-b-2 items-center justify-between flex-wrap'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              Wholegoods Search
            </h1>
          </div>
          {isLoading ? (
            <Loader />
          ) : searchData.length === 0 ? (
            <div className='text-center text-lg p-5'>
              Use the search to find products...
            </div>
          ) : (
            <SearchListTable data={searchData} equipmentType={1} />
          )}
        </div>
      </div>

      <EmailModal
        isOpen={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        equipment={selectedEquipment!}
        onSendSuccess={() => alert('Email sent!')}
      />
    </>
  );
}
